
import ApiService from '../services/apiService.js'
import router from '../router';

const accountModule = {
    namespaced: true,
    state: {
      isLoggedIn: false,
      websiteGuid: null,
      guid: null,
      firstName: null, 
      lastName: null, 
      phone: null,
      email: null,
      token: null
    },
    mutations: {
      setLoginData(state, loginData){    
        state.isLoggedIn = true;
        state.token = loginData.token;
        state.email = loginData.email;
        state.firstName = loginData.firstName;
        state.lastName = loginData.lastName;
        state.phone = loginData.phone;
        state.guid = loginData.guid;
        state.websiteGuid = loginData.websiteGuid;
      }, 
      logout(state){
        console.log('logout');
        //cleanup user state
        state.isLoggedIn = false;
        state.token = null;
        state.email = null;
        state.guid = null;
        state.firstName = null;
        state.lastName = null;
        state.phone = null;
        
        //redirect to login route 
        if(router.currentRoute.path != '/login'){
          console.log("redirect",router.currentRoute );
          //state.redirectAfterLogin = router.currentRoute;
          let curentRoute = null;
          if(router.currentRoute) curentRoute = router.currentRoute.path;
          router.replace({name: "login", query: { redirect: curentRoute }});
        }
      }, 
    },
    actions: {
      login(context, loginModel) {
        console.log('login action called', context, loginModel, ApiService)
        let websiteGuid = context.rootState.websiteGuid;
        return new Promise((resolve, reject) => {
          ApiService.login(loginModel.email, loginModel.password, websiteGuid)
            .then(result => {
              if(result.data.success){
                context.commit('setLoginData', {
                  token: result.data.result.token,
                  guid: result.data.result.guid,
                  websiteGuid: result.data.result.websiteGuid,
                  email: loginModel.email,
                  firstName: result.data.result.firstName,
                  lastName: result.data.result.lastName,
                  phone: result.data.result.phone,
                });
                context.commit('setWebsiteGui', result.data.result.websiteGuid, { root: true });
                resolve();
              }
              else
                reject(result.data.errors);
            })
            .catch((err) => {
              console.log('login error', err);
              reject(["Could not connect to server. Please try again."]);
            });
        });
      },
      tryGetToken(context) {
        if(!window.websiteSettings.useUserAuthentication) return;
        return new Promise((resolve, reject) => {
          ApiService.tryGetToken()
            .then(result => {
              if(result.data.success){
                context.commit('setLoginData', {
                  token: result.data.result.token,
                  guid: result.data.result.guid,
                  websiteGuid: result.data.result.websiteGuid,
                  email: result.data.result.email,
                  firstName: result.data.result.firstName,
                  lastName: result.data.result.lastName,
                  phone: result.data.result.phone,
                });
                context.commit('setWebsiteGui', result.data.result.websiteGuid, { root: true });
                resolve();
              }
              else
                reject(result.data.errors);
            })
            .catch((err) => {
              console.log('login error', err);
              reject(["Could not connect to server. Please try again."]);
            });
        });
      },
      //TODO: move this on main store and router there. Modules should use  context.commit('logout', null, { root: true }); ... maybe add dest address if not /login
      logout(context) {
        context.commit('logout');
        ApiService.logout();
      },
      getUserProfile(context){
       // console.log('getUserProfile action called', context)
        return new Promise((resolve, reject) => {
          let token = context.state.token; 
          ApiService.getUserProfile(context.state.websiteGuid, token)
            .then(result => {
              if(result.data.success){
              //  console.log('getUserProfile action called', context)
                resolve(result.data.result);
              }
              else{
                //console.log('getUserProfile action called', context)
                reject(result.data.errors);
              }
            })
            .catch( (err) => {
              //console.log('getUserProfile action has error', err);
              //if(err.response && err.response.status == 401){
                console.log(err)
                context.dispatch('logout');              
              //}
              reject(['Could not read user profile. An error occured.']);
            });
        });
      },
      updateUserProfile(context, userModel) {
         return new Promise((resolve, reject) => {
           let token = context.state.token; 
           ApiService.updateUserProfile(userModel, token)
             .then(result => {
               if(result.data.success){
                 console.log('updateUserProfile action called with success')
                 //update user account in store
                 resolve(result.data.result);
               }
               else{
                 console.log('updateUserProfile action called with errors')
                 reject(result.data.errors);
               }
             })
             .catch(err => {
               //console.log('getUserProfile action has error', err);
               if(err.response && err.response.status == 401){
                 context.dispatch('logout');              
               }
               reject(['Could not read user profile. An error occured.']);
             });
         });
      },
      getClientReservations(context) {
        return new Promise((resolve, reject) => {
          let token = context.state.token; 
          ApiService.getClientReservations(token)
            .then(result => {
              if(result.data.success){
                console.log('getClientReservations action called with success')
                //update user account in store
                resolve(result.data.result);
              }
              else{
                console.log('getClientReservations action called with errors')
                reject(result.data.errors);
              }
            })
            .catch(err => {
              console.log('getClientReservations action has error', err);
              if(err.response && err.response.status == 401){
                context.dispatch('logout');              
              }
              reject(['Could not read user profile. An error occured.']);
            });
        });
      }, 
      getReservationDetails(context, guid) {
        let token = context.state.token;
        return new Promise((resolve, reject) => {
          ApiService.getReservationDetails(guid, token)
          .then(result => {
            if(result.data.success){
              console.log('getReservationDetails action called with success')
              //update user account in store
              resolve(result.data.result);
            }
            else{
              console.log('getReservationDetails action called with errors')
              reject(result.data.errors);
            }
          })
          .catch(err => {
            console.log('getReservationDetails action has error', err);
            if(err.response && err.response.status == 401){
              context.dispatch('logout');              
            }
            reject(['Could not read user profile. An error occured.']);
          });
        });
      }
    },
    getters: {
      isAuthenticated: state => {
        return state.isLoggedIn;
      }
    }
  }

  export default accountModule;
